import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExerciceCategoryFiltersItemComponent } from "./exercice-category-filters-item/exercice-category-filters-item";
import { NgForOf, NgSwitch, NgSwitchCase, NgSwitchDefault } from "@angular/common";
import { ExerciceCategory } from "../../../common/models/exercice-category";
import { ExercicesProvider } from "../../providers/exercices-provider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule } from "@ngx-translate/core";
import { ExerciceCategoryThumbnailComponent } from "../exercice-category-thumbnail/exercice-category-thumbnail";

@Component({
  selector: 'exercice-category-filters',
  templateUrl: './exercice-category-filters.html',
  standalone: true,
  imports: [
    ExerciceCategoryFiltersItemComponent,
    NgForOf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule,
    ExerciceCategoryThumbnailComponent,
  ],
  styleUrls: ['./exercice-category-filters.scss']
})
export class ExerciceCategoryFiltersComponent implements OnInit {
  @Input() categories: ExerciceCategory[] = [];
  @Input() selectedCategoryIds: number[] = [];
  @Input() displayStyle: 'dropdown' | 'list' = 'list';
  @Output() onCategoryClicked: EventEmitter<number|undefined> = new EventEmitter<number|undefined>(); // if no id : all items

  protected allCategoriesItem: ExerciceCategory = {
    id: undefined,
    name: 'all_items',
    colorHex: '#333333',
  } as ExerciceCategory;

  constructor(
    private exercicesProvider: ExercicesProvider,
  ) {
  }

  ngOnInit() {
    // if no categories are provided, fetch them from the server
    if (this.categories.length === 0) {
      this.exercicesProvider.getExerciceCategories().subscribe({
        next: (categories: ExerciceCategory[]) => {
          this.categories = categories;
        }
      });
    }
  }

  onCategoryClick(categoryId: number|undefined) {
    this.onCategoryClicked.emit(categoryId);
  }

  onSelectChange(categoryIds: number[]|undefined) {
    // get only the new modification
    const newCategoryIds = categoryIds?.filter((id) => !this.selectedCategoryIds.includes(id));
    const removedCategoryIds = this.selectedCategoryIds.filter((id) => !categoryIds?.includes(id));
    if (newCategoryIds && newCategoryIds.length > 0) {
      this.onCategoryClicked.emit(newCategoryIds[0]);
    } else if (removedCategoryIds.length > 0) {
      this.onCategoryClicked.emit(removedCategoryIds[0]);
    } else {
      this.onCategoryClicked.emit(0);
    }
  }
}
